import {css} from '@emotion/css';
import {ResaleType} from '@remoov/functional';
import {theme} from '@remoov/remoov-components';
import React from 'react';
import {
  BoldInfoText,
  HideOnLargeScreen,
  HideOnSmallScreen,
  ImageBox,
  InfoText,
  ItemsBoardColumn,
  ItemsBoardContainer,
  ItemsBoardDivisionLine,
  ItemsBoardLeftContainer,
  ItemsBoardRightContainer,
  ItemsBoardRow,
  ResaleTypeChangeBadge,
} from './Common';

export type DonationBoardItemProps = {
  imgUrl: string;
  alt: string;
  category: string | number;
  quantity: number;
  resaleTypeBadge: Maybe<ResaleType>;
  onClick: () => unknown;
};

export const DonationBoardItem = ({
  imgUrl,
  alt,
  category,
  quantity,
  resaleTypeBadge,
  onClick,
}: DonationBoardItemProps) => (
  <ItemsBoardContainer className={css({backgroundColor: theme.colors.white})}>
    <ItemsBoardRow className={css({height: '130px'})}>
      <ImageBox
        onClick={onClick}
        className={css({
          margin: `0 ${theme.spacings.large}`,
          display: 'flex',
          alignItems: 'center',
        })}
      >
        <img src={imgUrl} alt={alt} />
      </ImageBox>

      <HideOnSmallScreen>
        <ItemsBoardRow>
          <ItemsBoardLeftContainer>
            <ItemsBoardColumn className={css({alignItems: 'flex-start'})}>
              <InfoText>{category}</InfoText>
              {resaleTypeBadge && <ResaleTypeChangeBadge resaleType={resaleTypeBadge} />}
            </ItemsBoardColumn>
          </ItemsBoardLeftContainer>

          <ItemsBoardRightContainer>
            <InfoText>{quantity}</InfoText>
          </ItemsBoardRightContainer>
        </ItemsBoardRow>
      </HideOnSmallScreen>

      <HideOnLargeScreen>
        <ItemsBoardRow className={css({marginBottom: theme.spacings.xsmall})}>
          <BoldInfoText className={css({marginRight: theme.spacings.xxsmall})}>
            Category:
          </BoldInfoText>
          <ItemsBoardColumn className={css({alignItems: 'flex-start'})}>
            <InfoText>{category}</InfoText>
            {resaleTypeBadge && <ResaleTypeChangeBadge resaleType={resaleTypeBadge} />}
          </ItemsBoardColumn>
        </ItemsBoardRow>

        <ItemsBoardRow>
          <BoldInfoText className={css({marginRight: theme.spacings.xxsmall})}>
            Quantity:
          </BoldInfoText>
          <InfoText>{quantity}</InfoText>
        </ItemsBoardRow>
      </HideOnLargeScreen>
    </ItemsBoardRow>

    <ItemsBoardDivisionLine />
  </ItemsBoardContainer>
);
